// Standardisierte Event-Typen für Auswahlfelder
export const EVENT_TYPES = [
  'Turnier',
  'Training',
  'Community-Event',
  'Livestream',
  'Workshop',
  'Vortrag',
  'Meetup',
  'LAN-Party',
  'Release-Event',
  'Coaching',
  'Bootcamp',
  'Q&A',
  'Charity',
  'Wettbewerb',
  'Testspiel',
  'Scrim',
  'Viewing Party',
  'Hackathon'
];
